var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VCreditCard',{attrs:{"trans":_vm.translations},on:{"change":_vm.creditInfoChanged}}),_c('b-button',{attrs:{"disabled":_vm.carregando,"block":"","variant":"success"},on:{"click":_vm.adicionar}},[(_vm.carregando)?_c('b-spinner'):_c('span',[_vm._v("Adicionar Cartão")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }